var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.$i18n.locale == 'th')?_c('span',[_vm._v(_vm._s(_vm._f("sumdatetime")(_vm.datetime)))]):_vm._e(),(_vm.$i18n.locale == 'en')?_c('span',[_vm._v(_vm._s(_vm._f("sumdatetimeen")(_vm.datetime)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }